// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"121":"e775e1bc","586":"1ba7eff1"}[chunkId] + ".js";
};